export default "__VITE_ASSET__DLAR$wes__"